import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { EmailContentService } from '../../core/services/email-content.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { UserService } from '../../core/services/user.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-email-content-new',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;新規作成</span>
    </div>
    <div class="card-body">
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      <form novalidate #emailContentForm="ngForm">
        <div class="row">
          <div class="col-md-12">
            @if (userRole === 30) {
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">作成店舗</label>
                  <select class="form-control" [(ngModel)]="form.studio" name="studio" required>
                    <option [ngValue]="null">-- 選択してください --</option>
                    @for (s of studios; track s.id) {
                      <option [ngValue]="s">{{ s.name }}</option>
                    }
                  </select>
                </div>
              </div>
            }
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">件名</label>
                <input type="text" class="form-control" [(ngModel)]="form.subject" name="subject" placeholder="件名（255文字以内）" maxlength="255" required>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">本文</label>
                <textarea class="form-control" [(ngModel)]="form.message" name="message" rows="20" placeholder="本文（65535文字以内）" sfMaxLength="65535" required></textarea>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-right">
                <a class="btn bg-close text-white" routerLink="/email/content"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                <button type="button" class="btn btn-success ml-1" (click)="save(emailContentForm)" [disabled]="saving || emailContentForm.invalid">
                  <i class="fa s-icon-save"></i>&nbsp;保存
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class EmailContentNewComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private emailContentService = inject(EmailContentService);
  private authState = inject(AuthStateService);
  private userService = inject(UserService);
  private router = inject(Router);
  private flash = inject(FlashService);

  form: any = {};
  studios: any[] = [];
  userRole = 30;
  saving = false;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('文面作成', 'edit_note', true);
    const user = this.authState.currentUser;
    if (user?.role) this.userRole = user.role;
    if (this.userRole === 30) {
      this.studios = await this.userService.getStudio('own') ?? [];
      if (this.studios.length > 0) this.form.studio = this.studios[0];
    }
  }

  async save(form?: NgForm): Promise<void> {
    if (form?.invalid) {
      form.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const payload = { ...this.form, studioId: this.form.studio?.id ?? null };
      delete payload.studio;
      await this.emailContentService.upsert(payload);
      // 旧版 email-content.js:177-186: success「メール文面を追加しました。」後に一覧へ
      this.flash.create('success', 'メール文面を追加しました。');
      this.router.navigate(['/email/content']);
    } finally {
      this.saving = false;
    }
  }
}
